export function validateConfig(config) {
    const requiredKeys = ['useCustomLayers', 'chapters', 'style'];
    requiredKeys.forEach(key => {
        if (typeof config[key] === 'undefined') {
            throw new Error(`Missing required config key: ${key}`);
        }
    });
}
